import React from "react";
import { LockKey, Cloud, DeviceMobile, ShieldCheck, Database, UserCircle, Check } from "@phosphor-icons/react";
import { SECURITY } from "../../data/startPageContent";
import useStartReveal from "./useStartReveal";
import StartShapes from "./StartShapes";
import "./StartSections.css";

const ICONS = { LockKey, Cloud, DeviceMobile, ShieldCheck, Database, UserCircle };

/** Security & compliance (plan §4.6). */
export default function StartSecurity() {
  const ref = useStartReveal();
  return (
    <section id="start-security" className="st-section st-section--alt st-sec st-light-shapes" aria-labelledby="st-sec-title">
      <StartShapes prefix="st-sec" kinds={["bubble", "dot"]} />
      <div className="st-container st-reveal" ref={ref}>
        <p className="st-overline st-center">{SECURITY.overline}</p>
        <h2 id="st-sec-title" className="st-h2 st-center">{SECURITY.title}</h2>
        <ul className="st-sec-checks" aria-label="עקרונות אבטחה">
          {SECURITY.checks.map((c) => (
            <li key={c}>
              <Check size={16} weight="bold" />
              {c}
            </li>
          ))}
        </ul>
        <div className="st-sec-grid">
          {SECURITY.pillars.map((p) => {
            const Icon = ICONS[p.icon] || ShieldCheck;
            return (
              <div key={p.title} className="st-sec-card">
                <span className="st-sec-icon" aria-hidden="true">
                  <Icon size={22} weight="fill" />
                </span>
                <h3 className="st-sec-card-title">{p.title}</h3>
                <p className="st-sec-card-text">{p.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
